<template>
  <div class="app-container">
	<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
		<el-form :inline="true" :model="queryParams">
			<el-form-item label="查询类型" prop="queryHistory">
			  <el-select v-model="queryParams.queryHistory"  placeholder="查询类型" clearable filterable style="width: 250px">
			    <el-option v-for="item in optionS" :key="item.value" :label="item.label" :value="item.value"/>
			  </el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" size="small" v-on:click="handleCurrentChange(1)">查询</el-button>
			</el-form-item>
		</el-form>
	</el-col>
    <el-table :data="list"  border>
	  <el-table-column label="用户ID" align="center" prop="recodeCode" />
	  <el-table-column prop="initiateUserHeadPortrait" label="头像" align="center">
	    <template slot-scope="scope">
	      <img v-if="scope.row.initiateUserHeadPortrait" slot="reference" :src="scope.row.initiateUserHeadPortrait" style="width: 50px;height: 50px;border-radius: 5px;object-fit: cover;">
	      <img v-if="scope.row.initiateUserHeadPortrait == null" slot="reference" src="http://523tongcheng.oss-cn-hangzhou.aliyuncs.com/webStorage/web_16662329564318713.png" style="width: 50px;height: 50px;border-radius: 50%;object-fit: cover;">
	     </template>
	  </el-table-column>
	  <el-table-column label="昵称" align="center" prop="initiateUserNickName" />
	  <el-table-column label="年龄" align="center" prop="initiateUserAge" />
	  <el-table-column label="性别" align="center" prop="initiateUserSex" >
		<template slot-scope="scope">
		  <span>{{scope.row.initiateUserSex===0?'男':'女'}}</span>
		</template>
	  </el-table-column>
	  <el-table-column label="审核时间" align="center" prop="endTime" width="180">
	    <template slot-scope="scope">
	      <span v-if="scope.row.endTime">{{timestampFormat(scope.row.endTime)}}</span>
	    </template>
	  </el-table-column>
	  <el-table-column label="申请时间" align="center" prop="createTime" width="180">
	    <template slot-scope="scope">
	      <span>{{timestampFormat(scope.row.createTime)}}</span>
	    </template>
	  </el-table-column>
      <el-table-column label="操作" align="center" width="150" v-if="user && user.isGuildLeader == 1 || user && user.isAdmin == 1">
        <template slot-scope="scope">
          <el-button size="mini" type="text" icon="el-icon-setting" v-if="scope.row.status == 0" @click="handleJoinApply(scope.row.applyId,1)">通过</el-button>
          <el-button size="mini" type="text" icon="el-icon-setting" v-if="scope.row.status == 0" @click="handleJoinApply(scope.row.applyId,2)">拒绝</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar" v-show="total > 0">
    	<el-pagination background layout="prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="queryParams.size" :total="total" style="float:right;">
    	</el-pagination>
    </el-col>
  </div>
</template>

<script>
import { getGuildApplyList,handleJoinApply } from "@/api/gonghui";
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 参数表格数据
      list: [],
      // 弹出层标题
      title: "入会审批",
      // 是否显示弹出层
      open: false,
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        page:1,
		size:10,
		guildId:null,
		queryHistory:0
      },
	  optionS:[{
	  	value:0,
	  	label:'审核中'
	  },{
	  	value:1,
	  	label:'历史数据'
	  }],
      // 表单参数
      form: {
        shopName:'',
        shopLogo:'',
      },
	  user:'',
      // 表单校验
      rules: {
    
      }
    };
  },
  created() {
	const data = JSON.parse(Cookies.get('user'))
	this.user = data
	this.queryParams.guildId = data.guildId
    this.getList();
  },
  methods: {
	zeroize(num) {
		return (String(num).length == 1 ? "0" : "") + num;
	},
	timestampFormat(timestamp) {
		var curTimestamp = parseInt(new Date().getTime() / 1000); //当前时间戳
		var timestampDiff = curTimestamp - parseInt(timestamp / 1000); // 参数时间戳与当前时间戳相差秒数
		var curDate = new Date(curTimestamp * 1000); // 当前时间日期对象
		var tmDate = new Date(parseInt(timestamp / 1000) * 1000); // 参数时间戳转换成的日期对象
		var Y = tmDate.getFullYear(),
		m = tmDate.getMonth() + 1,
		d = tmDate.getDate();
		var H = tmDate.getHours(),
		i = tmDate.getMinutes(),
		s = tmDate.getSeconds();
		return (Y + "-" + this.zeroize(m) + "-" + this.zeroize(d) + " " + this.zeroize(H) + ":" + this.zeroize(i) + ":" + this.zeroize(s));
	},
    /** 入会审批 */
	getList() {
	  this.loading = true;
	  getGuildApplyList(this.queryParams).then(response => {
	    this.loading = false
		this.list = response.rows
		console.log(this.list)
	    this.total = response.total;
	  });
	},
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
		logo:undefined,
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleCurrentChange(val) {
		this.queryParams.page = val;
		this.getList();
	},
	//通过拒绝
	handleJoinApply(id,status) {
        let that = this;
        this.$confirm(status===1?'确定审核通过吗？':'确定审核拒绝吗？').then(function() {
          handleJoinApply({
            applyId:id,
            status:status
          }).then(response => {
            that.$message({ message: response.msg, type: 'success'});
            that.getList();
          });
        })
    },

  }
};
</script>
<style>
	.el-table td, .el-table th{
		padding: 6px 0px;
	}
	.el-table{
		font-size: 12px;
	}
	.el-button+.el-button{
		margin-left: 0px;
	}
	.el-table th.gutter{
        display: table-cell!important;
    }
</style>


// WEBPACK FOOTER //
// ruhuishenpi.vue?015d0a1c